import { TAccount } from './accounts.types';

/**
 * Retrieves the timeout date of the latest formal offer on an account
 * @param account: TAccount- An Account object
 * @returns date as string or null
 */
export const getAccountLatestFormalOfferTimeOutDate = (account: TAccount) => {
    const formalOfferTimeOut = account.latest_formal_offer.timeout;
    if (formalOfferTimeOut) {
        return new Date(formalOfferTimeOut).toISOString();
    }
    return null;
};
